export enum StatutAvisEnum {
    ELABORE = "ELABORE",
    EN_ATTENTE = "EN_ATTENTE",
    ENVOYE = "ENVOYE",
    PUBLIE = "PUBLIE",
    REFUSE = "REFUSE",
    ANNULE = "ANNULE",
    EN_COURS = "Avis\u00a0non\u00a0conforme",
	IMPORTE="IMPORTE"
}
